// import "@fontsource/noto-sans-jp"
// import "./src/styles/base.css"
// import "./src/styles/blog-contents-style.css"

// export const onRouteUpdate = () => {
//     if (typeof document !== "undefined") {
//         const elements = document.querySelectorAll(".fadeInUp");

//         const observer = new IntersectionObserver(
//             (entries) => {
//                 entries.forEach((entry) => {
//                     if (entry.isIntersecting) {
//                         entry.target.classList.add("on");
//                     }
//                 });
//             },
//             { threshold: 0.1 }
//         );

//         elements.forEach((el) => observer.observe(el));

//         return () => {
//             elements.forEach((el) => observer.unobserve(el));
//         };
//     }
// };

// export const onClientEntry = () => {
//   if (typeof document !== "undefined") {
//     document.documentElement.classList.add("js");
//   }
// };







import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

export const onInitialClientRender = () => {
  const selectors = ['.headLine04', '.headLine07'];
  const titles = document.querySelectorAll(selectors.join(','));
  if (!titles.length) return;

  titles.forEach((el) => {

    // 元の HTML を取得（br を含む）
    let original = el.innerHTML;

    // すでに wave-char があれば二重実行しない
    if (el.querySelector('.wave-char')) return;

    // <br> をプレースホルダーに置き換え
    original = original.replace(/<br\s*\/?>/gi, '[[BR]]');

    // プレースホルダーごと分割
    const parts = original.split(/(\[\[BR\]\])/);

    let index = 0;

    // 1文字ずつ分解（[[BR]] はそのまま残す）
    const html = parts
      .map((part) => {
        if (part === '[[BR]]') return '<br>';

        return part
          .split('')
          .map((ch) => {
            const i = index++;
            if (ch === ' ') {
              return `<span class="wave-char space" style="--i:${i}">&nbsp;</span>`;
            }
            return `<span class="wave-char" style="--i:${i}">${ch}</span>`;
          })
          .join('');
      })
      .join('');

    el.innerHTML = html;
  });

  // ② IntersectionObserver で発火
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const chars = entry.target.querySelectorAll('.wave-char');
      // chars.forEach((char) => {
      //   char.style.animation = "wave 1.4s ease-in-out 5 forwards";
      //   char.style.animationDelay = `calc(var(--i) * 0.07s)`;
      // });


      chars.forEach((char) => {
  char.style.animation = "wave 1.4s ease-in-out 2 forwards";
  char.style.animationDelay = `calc(var(--i) * 0.07s)`;
});


      observer.unobserve(entry.target);
    });
  }, { threshold: 0.1 });

  titles.forEach((title) => observer.observe(title));
};
